import {CustomerContactPerson} from './CustomerContactPerson';
import {CustomerAddress} from './CustomerAddress';
import {ProductType} from './ProductType';
import {ProductContent} from './ProductContent';
import {ProductCategory} from './ProductCategory';
import {Contract} from './Contract';
import {BaseObject} from './BaseObject';

export class Product extends BaseObject {
    id: number;
    eshopExportId: number;
    eshopQueue: any;
    code = '0';
    type: ProductType = ProductType.product;
    productCategoryId: number;
    category: ProductCategory = new ProductCategory();
    name = '';
    description = '';
    hirePrice = 0;
    lossPrice = 0;
    storeDelay = 0;
    vat = 0;
    count = 0;
    packageCount = 0;
    isOverridenPrice = false;
    needDelivery = false;
    packagedIn: string = '';

    content: ProductContent[] = [];

    eshopVisible: boolean;
    eshopName: any;
    eshopTitle: string;
    eshopDescription: string;

    setHirePrice = (p: string): void => {
        this.hirePrice = this.convertToNumber(p);
    }

    getHirePriceWithVat = (): number => {
        return this.hirePrice + (this.hirePrice * this.vat / 100);
    }
}



// WEBPACK FOOTER //
// /app/src/model/Entities/Product.ts